import React, { useContext, useMemo, useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { entityConfigurations } from './constants';
import ImportAction from './ImportAction';
import ExportAction from './ExportAction';
import { usePermissions } from 'providers/RightsHooks';
import { ServiceContext } from 'providers/ServiceProvider';
import { getInt } from 'utils/functions';

const EntityTransferActions = () => {
  const location = useLocation();
  const [activeService] = useContext(ServiceContext);
  const route = location.pathname.replace('/' + activeService?.route, '');

  const [id, setId] = useState();
  const [hasAction, setHasAction] = useState({
    import: false,
    export: false
  });

  const entityConfiguration = useMemo(
    () =>
      entityConfigurations.find(configuration => {
        let hasImportAction = false,
          hasExportAction = false;
        if (configuration.routes.import) {
          const match = matchPath(route, { path: configuration.routes.import, exact: true });
          if (match) hasImportAction = true;
        }
        if (configuration.routes.export) {
          const match = matchPath(route, { path: configuration.routes.export, exact: true });
          if (match) {
            hasExportAction = true;
            const idParamName = configuration.idParamName || 'id';
            if (idParamName && match.params[idParamName]) setId(getInt(match.params[idParamName]));
          }
        }
        setHasAction({
          import: hasImportAction,
          export: hasExportAction
        });
        return hasImportAction || hasExportAction;
      }),
    [route]
  );

  const hasImportPermission = usePermissions(entityConfiguration?.permissions?.import);
  const hasExportPermission = usePermissions(entityConfiguration?.permissions?.export);

  const hasImportAction = useMemo(
    () => hasImportPermission && hasAction.import && entityConfiguration,
    [hasImportPermission, hasAction, entityConfiguration]
  );
  const hasExportAction = useMemo(
    () => hasExportPermission && hasAction.export && id && entityConfiguration,
    [hasExportPermission, hasAction, id, entityConfiguration]
  );

  return (
    <>
      {hasImportAction && <ImportAction type={entityConfiguration.name} redirectUrl={entityConfiguration.routes.redirect} />}
      {hasExportAction && <ExportAction type={entityConfiguration.name} id={id} />}
    </>
  );
};

export default EntityTransferActions;
